import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/mpesa/mpesaErreo.webp'


const _hoisted_1 = { class: "result-expired" }
const _hoisted_2 = { class: "tips" }

import useOrderStore from '@/store/order'
import SvgIcon from 'components/svgIcon/index.vue'
import { computed } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'expired',
  setup(__props) {

const orderStore = useOrderStore()
const text = computed(
  () =>
    orderStore.expiredText ||
    `Your payment order has expired, please re-create the order. If you have any questions, please feel free to contact us.`
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("img", {
      src: _imports_0,
      class: "image-center"
    }, null, -1)),
    _createElementVNode("p", _hoisted_2, _toDisplayString(text.value), 1)
  ]))
}
}

})